import React, { PureComponent } from 'react';

import FileCommitSelector from '../containers/file-commit-selector';
import FileModeSelector from '../containers/file-mode-selector';
import FullCommitLink from '../containers/full-commit-link';
import RefSelector from '../containers/ref-selector';

import * as styles from './file-header.style';

type FileHeaderProps = {
  path: string;
};

export default class FileHeader extends PureComponent<FileHeaderProps> {
  render() {
    const { path } = this.props;

    return (
      <styles.HeaderContainer>
        <FileModeSelector mode="source" path={path} />
        <RefSelector path={path} />
        <FileCommitSelector path={path} />
        <FullCommitLink path={path} />
      </styles.HeaderContainer>
    );
  }
}
